export default __webpack_public_path__ + "static/media/plus.d5291e5d.svg";